module.exports = __webpack_public_path__ + "img/task-2-g.ebbf9bf1.png";